import { buildQueryFromKeyValuePairs, ProductType, UrlParamKeyValuePair } from '../../common';
import { getSFCCRefererLink, getSFCCReferralSourceCode } from '../../sfcc/utilities';
import { getPricingApiConfig } from '../api/pricing-api';
import { formatMarketRegion } from './uppercase-market-region';

export const getFetchSFCCPricesUrlByIds = (
  entityIds: number[],
  entityType: ProductType
): string => {
  const { marketLocale, baseUrl } = getPricingApiConfig();
  const sfccLocale = formatMarketRegion(marketLocale);
  const entityTypeParameterValue = entityType === ProductType.Family ? 'Family' : 'Group';
  const sourceCode = getSFCCReferralSourceCode();

  // Build the base query parameters
  const urlParamKeyValuePairs: UrlParamKeyValuePair[] = [
    { key: 'c_method', value: `get${entityTypeParameterValue}Prices` },
    { key: 'q', value: `pim${entityTypeParameterValue}Id` },
    { key: 'c_IDs', value: entityIds.join(',') },
    { key: 'locale', value: sfccLocale },
  ];

  // Add optional parameters
  if (sourceCode) {
    urlParamKeyValuePairs.push({ key: 'sourceCode', value: sourceCode });

    const refererLink = getSFCCRefererLink();
    if (refererLink) {
      urlParamKeyValuePairs.push({ key: 'referer', value: refererLink });
    }
  }

  // Build and return the final URL
  const queryString = buildQueryFromKeyValuePairs(urlParamKeyValuePairs);
  return `${baseUrl}/product_search/prices?${queryString}`;
};
